export default [
  {
    path: '/test-v2',
    name: 'test-v2',
    component: () => import('../views/pages/starter.vue'),
    meta: {
      title: 'Test V2',
      authRequired: true,
    },
  },
  {
    path: '/booking/monitoring',
    name: 'booking-monitoring',
    component: () => import('../views/booking/booking_monitoring.vue'),
    meta: {
      title: 'Booking Tasks & Monitoring',
      authRequired: true,
    },
  },
  {
    path: '/booking/export_sea',
    name: 'export_sea',
    meta: {
      title: 'Export Sea',
      authRequired: true,
    },
    component: () => import('../views/booking/export_sea.vue'),
  },
  {
    path: '/duties_taxes',
    name: 'duties_taxes',
    meta: {
      title: 'Duties and Taxes',
      authRequired: true,
    },
    component: () => import('../views/duties_taxes/duties_taxes.vue'),
  },
];
